import React from 'react'
import PageLayout from 'layouts/PageLayout'
import EmptyHeader from 'containers/EmptyHeader'
import LoadingState from 'components/LoadingState'
import Footer from 'components/Footer'

export const SsoLoadingPage = () => (
  <PageLayout header={<EmptyHeader hideUser />} footer={<Footer />}>
    <LoadingState />
  </PageLayout>
)
